module.exports = __webpack_public_path__ + "img/1leftB.883cc76d.png";